module.exports = __webpack_public_path__ + "static/media/image-992.cd4e3d2a.webp";